module.exports = __webpack_public_path__ + "img/Personality test Icon - white.3f0c27c4.svg";